export default __webpack_public_path__ + "static/media/TTAConnectBlueLogo.7dd902cc.svg";